import { useMemo } from "react";

import numeral from "numeral";

import type { ColumnType } from "@similarweb/pro-logic-components";
import { TextCell } from "@similarweb/pro-logic-components";

import { useTranslation } from "pro-features/components/WithTranslation";

import { NoDataCell } from "../../../components/NoDataCell";

export interface IShareColumnData {
    share?: number | null;
}

export const useShareColumnConfig = () => {
    const translate = useTranslation();

    return useMemo(
        () =>
            ({
                title: translate("bt.report.channels.share-of-channel-traffic-competitors-table.traffic-share"),
                dataIndex: "share",
                align: "right",
                width: 120,
                render: (value) => {
                    if (value == null) {
                        return <NoDataCell />;
                    }

                    return <TextCell>{numeral(value).format("0.00%")}</TextCell>;
                },
            }) satisfies ColumnType<IShareColumnData>,
        [translate],
    );
};
